import React from 'react';
import DashboardPanel from '../../components/DashboardPanel';

const Dashboard = () => <DashboardPanel />;

export default Dashboard;
